import { CenterContent, Icon, IconWithText } from "shared/styles";
import { Title } from "shared/components";
import { copy } from "shared/assets";
import { getIcon, ICONS } from "shared/utils";
import { Spacer } from "shared/layout";
import { colors, ContentWidth } from "shared/styles/constants";
import { SubscriptionList } from "Bands/pages/subscription/containers";
import { useSubscriptionContext } from "Bands/contexts";
import { useBandRoute } from "Bands/utils";
import { BAND_PATHS } from "Bands/router";
import { SubscriptionType } from "Bands/types";

const subscriptionCopy = copy.subscription.page;

export const SubscriptionOverview = () => {
  const { pushRoute } = useBandRoute();
  const { chooseSubscription } = useSubscriptionContext();

  const onSelect = (plan: SubscriptionType) => {
    chooseSubscription(plan);
    pushRoute(BAND_PATHS.SUBSCRIPTION_BILLING_INFO);
  };

  return (
    <CenterContent width={ContentWidth.wide}>
      <Spacer size="xxl" align="center">
        <CenterContent>
          <Spacer size="xxl" align="center">
            <Title asComponent="h2" title={subscriptionCopy.info.title} />
            <Spacer size="l">
              {subscriptionCopy.info.bullets?.map(
                ({ text, icon }: { text: string; icon: string }) => (
                  <IconWithText>
                    <Icon
                      as={getIcon(icon as ICONS)}
                      size="xxl"
                      color={colors.grey5}
                    />
                    <span>{text}</span>
                  </IconWithText>
                )
              )}
            </Spacer>
          </Spacer>
        </CenterContent>
        <Title asComponent="h2" title={subscriptionCopy.choose} />
        <SubscriptionList onSelect={onSelect} />
      </Spacer>
    </CenterContent>
  );
};
